import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import { localize } from 'helpers/translator'

import MainButton from 'components/button/main/main_button'
import styles from './PairHolder.scss'

const PairHolder = props => (
	<div styleName={cn({
		PairHolder: true,
		'PairHolder--big': props.size === 'big',
	})}>
		<div styleName={
			cn({
				'PairHolder-container': true,
				'PairHolder-container--error': props.error,
			})}>
			<div styleName="PairHolder-container-addPairButton">
				{props.size === 'normal' && <MainButton onClick={props.addPairHandler}>{localize('matching_pairs_ct_add_pair')}</MainButton>}
				{props.size === 'big' && <MainButton onClick={props.addPairHandler} size='big'>{localize('matching_pairs_ct_add_pair')}</MainButton>}
			</div>
		</div>
		{props.error && <div styleName="PairHolder-errorMessage">{localize('matching_pairs_ct_add_pair_error')}</div>}
	</div>
)

PairHolder.propTypes = {
	showAddPairModal: PropTypes.func.isRequired,
	error: PropTypes.bool,
	size: PropTypes.oneOf(['normal', 'big']),
}

PairHolder.defaultProps = {
	showAddPairModal: () => { },
	size: 'normal',
}

export default CSSModules(PairHolder, styles, { allowMultiple: true })
